import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, SlidersHorizontal } from "lucide-react";
import { useData } from "../lib/DataContext";
import { api, errMsg } from "../lib/api";
import { PageHeader, Panel, TierBadge, Qty } from "../components/shared";
import AdjustDialog from "../components/AdjustDialog";

function Row({ it, onAdjust }) {
  const { refreshAll } = useData();
  const [busy, setBusy] = useState(false);
  const clear = async () => {
    setBusy(true);
    try { await api.put(`/items/${it.id}/reconcile`, { flag: false }); await refreshAll(); toast.success(`${it.name} cleared`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid={`recon-row-${it.sku}`} className="flex flex-col md:flex-row md:items-center gap-3 p-4 border-b border-[#1E293B] last:border-0">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2"><TierBadge tier={it.tier} /><span className="font-semibold truncate">{it.name}</span></div>
        <div className="font-mono text-[11px] text-[#6B7280] mt-1">{it.sku} · {it.category} · flagged {it.reconcile_flagged_at ? new Date(it.reconcile_flagged_at).toLocaleString() : "—"}</div>
      </div>
      <Qty v={it.stock} unit={it.unit} className="text-2xl font-bold md:w-40 md:text-right" />
      <div className="flex gap-2">
        <button data-testid={`recon-adjust-${it.sku}`} onClick={() => onAdjust(it.id)}
          className="h-12 px-4 rounded-md border border-[#334155] text-sm font-semibold flex items-center gap-2 hover:border-[#F59E0B] hover:text-[#F59E0B]"><SlidersHorizontal className="w-4 h-4" />Count Adjust</button>
        <button data-testid={`recon-clear-${it.sku}`} onClick={clear} disabled={busy}
          className="h-12 px-4 rounded-md bg-[#A78BFA] text-[#090D16] text-sm font-bold flex items-center gap-2 hover:bg-[#C4B5FD] disabled:opacity-50"><CheckCircle2 className="w-4 h-4" />Clear</button>
      </div>
    </div>
  );
}

export default function Reconciliation() {
  const { items } = useData();
  const [adj, setAdj] = useState(null);
  const list = items.filter((i) => i.needs_reconciliation).sort((a, b) => (a.reconcile_flagged_at || "").localeCompare(b.reconcile_flagged_at || ""));
  return (
    <div>
      <PageHeader kicker="// STOCK COUNT REVIEW" title="Reconciliation Required" />
      <Panel data-testid="recon-list">
        {list.map((it) => <Row key={it.id} it={it} onAdjust={setAdj} />)}
        {!list.length && <div data-testid="recon-empty" className="p-8 text-center font-mono text-[#6B7280]">NOTHING FLAGGED · TICK RECON ON A DASHBOARD CARD TO ADD ONE</div>}
      </Panel>
      <AdjustDialog item={adj ? items.find((i) => i.id === adj) : null} defaultType="adjustment" onClose={() => setAdj(null)} />
    </div>
  );
}
